﻿module Client.ContractPage.ChangeOrders.Headers

open FSharpPlus
open Client
open Fable.FontAwesome
open Fable.React
open Feliz
open Feliz.Bulma
open Feliz.UseElmish
open PortalLibs.Client.Util
open Client.ContractPage.ChangeOrders.Rows
open Shared.Models
open PortalLibs.Shared

let TopRow =
  React.memo<{| Header: ChangeOrderHeader; ChildrenItems: ChangeOrderHeader -> ReactElement
                Expanded: bool; Expand: int64 -> unit; Collapse: int64 -> unit |}>(
    name = "ChangeOrderRow",
    areEqual = Helpers.equalsButFunctions,
    withKey = (fun props -> props.Header.Id.ToString()),
    render = fun props ->
      
    let expanded = props.Expanded
    let toggle = if expanded then props.Collapse else props.Expand
    let header = props.Header
    let isApproved = header.Type = ChangeOrderType.Approved
    
    React.fragment [
      Html.tr [
        prop.onClick (fun _ -> toggle header.Id)
        if expanded then prop.style[selectedRow]
        prop.children [
          Html.td [
            prop.style [style.textAlign.right]
            prop.text(header.ACO |> Option.emptyStrIfNone)
          ] 
          Html.td [
            Html.a [
              Html.div [
                prop.style[ style.display.flex; style.justifyContent.spaceBetween ]
                prop.children [
                  Html.strong[ header.Description |> emptyStrTagIfNone ]
                  Bulma.icon [
                    prop.style [ style.color "#b5b5b5" ]
                    prop.children [
                      Fa.i [ if expanded then Fa.Solid.ChevronUp else Fa.Solid.ChevronDown ] []
                    ]
                  ]
                ]
              ]
            ]
          ]
          if isApproved then
            Html.td [
              prop.text (header.ApprovalDate |> prettyPrintDateOptionLong)
            ]
        ]
      ]
      if expanded then
        Html.tr [
          Html.td [
              prop.colSpan (if isApproved then 5 else 4)
              prop.className "change-orders-row-expanded"
              prop.children [props.ChildrenItems header]
          ]
        ] 
    ]
  )

let TopRows = 
  React.memo<{| Headers: ChangeOrderHeader list
                ChildrenItems: ChangeOrderHeader -> ReactElement |}, ReactElement list>(
      name = "TopRows",
      render = fun props ->
      let state, dispatch = React.useElmish(init, update, [| |])
      
      props.Headers |>> (fun header ->
        TopRow {| Header = header; Collapse = (Collapse >> dispatch)
                  Expand = (Expand >> dispatch); Expanded = state.Expanded |> List.contains header.Id
                  ChildrenItems = props.ChildrenItems
               |}
      )
  )
let View (headers: ChangeOrderHeader list) orderType childrenItems =
  let matchOrderType app pen =
    match orderType with
    | ChangeOrderType.Approved -> app
    | ChangeOrderType.Pending -> pen
    | _ -> failwith "Invalid Change Order Type"
    
  let title = matchOrderType "Approved" "Pending"
  let acoName = matchOrderType "ACO" "PCO"
  Html.div [
    prop.style [
      style.paddingBottom (length.px 50)
      style.marginLeft(length.auto); style.marginRight(length.auto);
      style.display.flex; style.flexDirection.column
    ]
    prop.children [
      Bulma.title.h5($"{title} Change Orders")
      Bulma.table [
        prop.style [ style.alignSelf.flexEnd; Styles.stickyTableBorder ]
        table.isFullWidth
        table.isHoverable
        prop.children [
          Html.thead [
            Html.tr [
              prop.style (Styles.sticky(zIndex = 2))
              prop.children [
              Html.th [
                prop.style [ style.textAlign.right; style.width(length.percent 5) ]
                prop.text acoName
              ]
              Html.th [
                prop.style [ style.width(length.percent (matchOrderType 60 95)) ]
                prop.text "Description"
              ]
              if orderType = ChangeOrderType.Approved then
                Html.th [
                  prop.style [ style.width(length.percent 35) ]
                  prop.text "Approval Date"
                ]
              ]
            ]
          ]
          Html.tbody [
            match headers with
            | [] ->
              yield Html.tr [
                Html.td [
                  prop.colSpan (if orderType = ChangeOrderType.Approved then 3 else 2)
                  prop.style [style.textAlign.center; style.padding(length.px 30, 0) ]
                  prop.text "No Pending Change Orders"
                ]
              ]
            | _ -> yield TopRows {| Headers = headers; ChildrenItems = childrenItems |}
          ]
        ]
      ]
    ]
  ]